module.exports = __webpack_public_path__ + "static/visa-bitcoin-vityaz-3415fe1b8f5435a7f873ae469b7db091.png";